import { Component, inject, Input, OnInit, signal } from '@angular/core';
import { CoreModule, emailValidator, FormComponent, OffersType, phoneValidator } from '@toevla-webapplications/core';
import { FormArray, FormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { Store } from '@ngrx/store';
import { IvvaStore } from '../../../../../../store/store.model';
import { take } from 'rxjs';
import { User } from '../../../../../../services/user/user.model';
import { BookingService } from '../../../../../../services/booking/booking.service';

@Component({
    selector: 'ivva-booking-details',
    templateUrl: './booking-details.component.html',
    styleUrls: ['./booking-details.component.scss'],
    imports: [TranslateModule, ReactiveFormsModule, CoreModule]
})
export class BookingDetailsComponent extends FormComponent implements OnInit {
	@Input()
	type: OffersType;

	user = signal<User | null>(null);

	readonly OffersType = OffersType;

	private readonly bookingService = inject(BookingService);
	private readonly fb = inject(FormBuilder);
	private readonly store = inject(Store<IvvaStore>);

	get companions(): FormArray {
		return this.form?.get('companions') as FormArray;
	}

	ngOnInit() {
		this.store
			.select('offers', 'user')
			.pipe(take(1))
			.subscribe((user) => {
				this.user.set(user);
				this.createForm();
			});
	}

	addCompanion(comp?: any) {
		const companion = this.fb.group({
			fullName: [comp?.fullName, Validators.required],
			age: [comp?.age, [Validators.required, Validators.min(1)]],
			eligibleForDiscount: [comp?.eligibleForDiscount || false],
		});

		this.companions.push(companion);
	}

	removeCompanion(index: number) {
		this.companions.removeAt(index);
	}

	private createForm() {
		const data = this.bookingService.getCurrentBooking();

		this.form = this.fb.group({
			booker: this.fb.group({
				firstName: [data.booker?.firstName || this.user()?.firstName, Validators.required],
				lastName: [data.booker?.lastName || this.user()?.lastName, Validators.required],
				email: [data.booker?.email, [Validators.required, emailValidator]],
				alternativeEmail: [data.booker?.alternativeEmail, emailValidator],
				phone: [data.booker?.phone, [Validators.required, phoneValidator]],
				age: [data.booker?.age, [Validators.required, Validators.min(18)]],
			}),
			companions: this.fb.array([]),
		});

		if (!this.user()?.socialOrg) {
			this.form.get('booker.firstName')?.disable();
			this.form.get('booker.lastName')?.disable();
		}

		data.companions?.forEach((comp: any) => {
			this.addCompanion(comp);
		});
	}
}
